export default "__VITE_ASSET__BDg8CEsp__";